import React from 'react'
import styled from 'styled-components'
import { Small } from '../../../utils/style'

const LegalCopy = styled(Small)`
  display: block;
  text-align: left;
  margin-top: auto;
  color: ${(props) => props.theme.colors.blue};
  line-height: 1.4;
`

export const Legal = ({ terms }) => {
  if (terms) {
    return <LegalCopy dangerouslySetInnerHTML={{ __html: terms }} />
  }

  return (
    <LegalCopy>
      Representative finance example. Final quote subject to confirmation of
      your personal circumstances and credit status. Terms &amp; Conditions
      apply.
    </LegalCopy>
  )
}
